import { ExpandMore } from '@mui/icons-material'
import {
  Accordion,
  AccordionDetails,
  AccordionProps,
  AccordionSummary,
  styled,
  Typography
} from '@mui/material'

const StyledAccordion = styled(Accordion)(({ theme }) => ({
  borderRadius: '8px',
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
  '&:before': {
    display: 'none'
  }
}))

/**
 * Props for the AccordionBase component
 */
interface IAccordionBaseProps extends AccordionProps {
  /** The title of the accordion */
  title: string
}

/**
 * AccordionBase component
 * This component renders a styled accordion with a title and content.
 * It uses MUI's Accordion components and allows for custom styling.
 *
 * @param {IAccordionBaseProps} props - The properties for the accordion component.
 * @returns {JSX.Element} The rendered accordion component.
 */
export const AccordionBase: React.FC<IAccordionBaseProps> = ({
  title,
  content,
  children,
  ...props
}) => {
  return (
    <StyledAccordion {...props}>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Typography fontWeight='bold'>{title}</Typography>
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </StyledAccordion>
  )
}

export default AccordionBase
